<list-view [liste]="geographieService.listePays" *ngIf="geographieService.listePays"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>